import React, { useState, useEffect } from 'react'; // <--- Añade useEffect
import { getFunctions, httpsCallable } from 'firebase/functions';
import { useNavigate } from 'react-router-dom';

const ProLandingPage = ({ userProfile }) => {
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    // TRUCO: Si el usuario vuelve a esta página (botón Atrás), reseteamos el loading
    useEffect(() => {
        const handleFocus = () => setIsLoading(false);
        window.addEventListener('focus', handleFocus);
        return () => window.removeEventListener('focus', handleFocus);
    }, []);

    const handleSubscribe = async () => {
        if (!userProfile) {
            navigate('/login');
            return;
        }
        setIsLoading(true);
        try {
            const functions = getFunctions();
            const createSession = httpsCallable(functions, 'createProCheckoutSession');
            
            // TU PRICE_ID AQUÍ
            const PRICE_ID = "price_1SZ0PbRDgzLGjOjK0LxbLIuo"; 

            const { data } = await createSession({ 
                priceId: PRICE_ID,
                successUrl: window.location.origin + '/dashboard', 
                cancelUrl: window.location.href 
            });
            
            window.location.assign(data.url); 

        } catch (error) {
            console.error("Error suscripción:", error);
            alert("Hubo un problema al iniciar el pago.");
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-black text-white flex flex-col relative overflow-hidden">
            {/* Fondo decorativo AZUL */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none">
                <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-blue-900/40 rounded-full blur-3xl"></div>
                <div className="absolute bottom-[-10%] left-[-10%] w-[500px] h-[500px] bg-[#44EFFF]/10 rounded-full blur-3xl"></div>
            </div>

            <div className="relative z-10 max-w-5xl mx-auto px-6 py-20 flex-grow flex flex-col items-center text-center">
                
                {/* Badge Azul */}
                <span className="px-4 py-1.5 rounded-full bg-gradient-to-r from-[#44EFFF] to-blue-600 text-black font-black text-xs uppercase tracking-widest mb-8 shadow-[0_0_20px_rgba(68,239,255,0.3)]">
                    Typefiction PRO
                </span>

                {/* Titulo con Gradiente Azul */}
                <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
                    Desata tu <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-[#44EFFF] to-blue-500">Poder Creativo</span>.
                </h1>

                <p className="text-xl text-gray-400 max-w-2xl mb-12">
                    Lleva tus historias al siguiente nivel con herramientas diseñadas para autores serios.
                </p>

                {/* Grid de Beneficios */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full mb-16">
                    {/* Feature 1 */}
                    <div className="bg-gray-900/50 border border-gray-800 p-8 rounded-2xl hover:border-[#44EFFF]/50 transition-colors group">
                        <div className="w-12 h-12 bg-gray-800 rounded-lg flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform text-[#44EFFF]">📊</div>
                        <h3 className="text-xl font-bold mb-2 text-white">Dashboard Avanzado</h3>
                        <p className="text-gray-400 text-sm">Visualiza estadísticas detalladas de tus historias, vistas y seguidores en un solo lugar.</p>
                    </div>

                    {/* Feature 2 */}
                    <div className="bg-gray-900/50 border border-gray-800 p-8 rounded-2xl hover:border-[#44EFFF]/50 transition-colors group">
                        <div className="w-12 h-12 bg-gray-800 rounded-lg flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform text-[#44EFFF]">☁️</div>
                        <h3 className="text-xl font-bold mb-2 text-white">Borradores en Nube</h3>
                        <p className="text-gray-400 text-sm">Guarda capítulos ilimitados en la nube y continúa escribiendo desde cualquier dispositivo.</p>
                    </div>

                    {/* Feature 3 */}
                    <div className="bg-gray-900/50 border border-gray-800 p-8 rounded-2xl hover:border-[#44EFFF]/50 transition-colors group">
                        <div className="w-12 h-12 bg-gray-800 rounded-lg flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform text-[#44EFFF]">🚀</div>
                        <h3 className="text-xl font-bold mb-2 text-white">Estrenos Programados</h3>
                        <p className="text-gray-400 text-sm">Programa lanzamientos automáticos o crea "Hype" con capítulos bloqueados y cuenta regresiva.</p>
                    </div>
                </div>

                {/* CTA Final */}
                <div className="bg-gradient-to-b from-gray-800 to-gray-900 p-1 rounded-2xl w-full max-w-md shadow-2xl hover:shadow-[0_0_30px_rgba(68,239,255,0.15)] transition-shadow">
                    <div className="bg-black rounded-xl p-8 flex flex-col items-center">
                        <p className="text-gray-400 mb-2">Suscripción Mensual</p>
                        <div className="flex items-baseline gap-1 mb-6">
                            <span className="text-4xl font-bold text-white">MXN $60.00</span>
                            <span className="text-gray-500">/mes</span>
                        </div>
                        
                        <button 
                            onClick={handleSubscribe}
                            disabled={isLoading}
                            className="w-full py-4 rounded-lg font-bold text-lg bg-[#44EFFF] text-black hover:bg-[#33c9d6] transition-all transform hover:scale-105 disabled:opacity-50 disabled:scale-100 shadow-lg shadow-[#44EFFF]/20"
                        >
                            {isLoading ? 'Procesando...' : 'Obtener PRO Ahora'}
                        </button>
                        <p className="text-xs text-gray-600 mt-4">Cancela cuando quieras. Sin compromisos.</p>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ProLandingPage;